import styled from '@emotion/styled';
import { uiTheme as t } from './theme';
import { segmentTrackStyle, segmentItemStyle, segmentCountStyle } from './SegmentedTabs';

export interface MetricPillProps {
  label: string;
  value: number | string;
}

// Los tres estilos vienen de `SegmentedTabs`, no copiados sino importados: la
// píldora se coloca a su lado y tiene que medir exactamente igual. Copiando los
// valores, el día que alguien cambie el relleno de las pestañas esta fila se
// desalinea y ninguna prueba se entera.
const Shell = styled.div(segmentTrackStyle);

const Body = styled.span({
  ...segmentItemStyle,
  fontWeight: 500,
  color: t.color.text,
  background: 'transparent',
  whiteSpace: 'nowrap',
});

const Value = styled.span(segmentCountStyle);

/**
 * Primitivo: una métrica suelta con el aspecto de una pestaña.
 *
 * Existe para poner un dato al lado de `SegmentedTabs` sin meterlo dentro: una
 * pestaña más sugeriría que se puede pulsar y que filtra la tabla, y esto solo
 * informa.
 *
 * No es `CountBadge`: aquel es una píldora de conteo suelta, sin etiqueta ni
 * carril, para encabezados de tarjeta.
 */
const MetricPill = ({ label, value }: MetricPillProps) => (
  <Shell>
    <Body>
      {label}
      <Value>{value}</Value>
    </Body>
  </Shell>
);

export default MetricPill;
